/* 🤖 this file was generated by svg-to-ts */
export const kzIconsPlay: {
  name: 'play';
  data: string;
} = {
  name: 'play',
  data: `<svg version="1.0" viewBox="0 0 599 719"><path d="M56.5 3.5c-3.8.9-11.3 3.6-16.5 6.2C23 18 10.7 33.1 6 51.6 4 59.2 4 64 4 359s0 299.8 2 307.4c3 11.7 8.2 20.9 17 29.6 13.1 13 28.6 19.4 47 19.4 12.2 0 19.8-1.7 30.3-7 8.2-4.1 461.4-291.6 469.9-298.1 8.1-6.2 14.3-13.7 18.8-22.8 13.8-28.2 6.1-60.8-18.8-79.8-5.2-4-456.8-291-467.3-297C89.9 3.3 71.1.4 56.5 3.5zm20 58.4c2.8 1.6 107.4 68 232.5 147.4 151.4 96.2 228 145.4 229 147.1 1.3 2.3 1.3 2.9 0 5.2-1 1.7-78.4 51.4-232.9 149.5C99.6 641.5 73.3 658 69.8 658c-2.8 0-4.6-.7-6.3-2.5l-2.5-2.4V359.3c0-263.4.2-294.1 1.5-296.1 1.3-1.7 4.9-3.5 8.5-4.1.3 0 2.8 1.2 5.5 2.8z" fill="currentColor"/></svg>`
};
